import { AppCustomEvent } from '@types'
import { ReactNode } from 'react'

export type ToastBaseOptions = {
  dismissOnLogout?: boolean
  forceKeepVisible?: boolean
}

export type RegisterToastEvent = CustomEvent<
  {
    title: string
    message?: string
    variant: 'info' | 'success' | 'error'
  } & ToastBaseOptions
>

interface NotificationsProps {
  title: string
  message?: string

  // this will force the toast to stay visible and ignore dismiss() calls
  forceKeepVisible?: boolean
}

export const toaster = {
  info: (props: NotificationsProps) => {
    window.dispatchEvent(
      new CustomEvent(AppCustomEvent.REGISTER_TOAST, {
        detail: {
          title: props.title,
          message: props.message,
          variant: 'info',
          forceKeepVisible: props.forceKeepVisible,
        },
      }),
    )
  },

  success: (props: NotificationsProps) => {
    window.dispatchEvent(
      new CustomEvent(AppCustomEvent.REGISTER_TOAST, {
        detail: {
          title: props.title,
          message: props.message,
          variant: 'success',
        },
      }),
    )
  },

  error: (props: NotificationsProps) => {
    window.dispatchEvent(
      new CustomEvent(AppCustomEvent.REGISTER_TOAST, {
        detail: {
          title: props.title,
          message: props.message,
          variant: 'error',
        },
      }),
    )
  },

  dismissAll: () => {
    window.dispatchEvent(new CustomEvent(AppCustomEvent.DISMISS_ALL_TOASTS))
  },

  dismissCurrent: () => {
    window.dispatchEvent(new CustomEvent(AppCustomEvent.DISMISS_CURRENT_TOAST))
  },

  custom: (notificationJSX: ReactNode, props?: ToastBaseOptions) => {
    window.dispatchEvent(
      new CustomEvent(AppCustomEvent.REGISTER_CUSTOM_TOAST, {
        detail: {
          notificationJSX,
          forceKeepVisible: props?.forceKeepVisible,
          dismissOnLogout: props?.dismissOnLogout,
        },
      }),
    )
  },
}

type NotificationsHookProps = {
  title: string
  message?: string
  variant: 'info' | 'success' | 'error'
}

export const useToast = () => {
  return {
    toast: (props: NotificationsHookProps) => {
      if (typeof window !== 'undefined') {
        window.dispatchEvent(
          new CustomEvent(AppCustomEvent.REGISTER_TOAST, {
            detail: {
              title: props.title,
              message: props.message,
              variant: props.variant,
            },
          }),
        )
      }
    },
    dismiss: () => {
      toaster.dismissAll()
    },
  }
}
